import { render, staticRenderFns } from "./fkShouYe.vue?vue&type=template&id=68ac4ae9&"
import script from "./fkShouYe.vue?vue&type=script&lang=js&"
export * from "./fkShouYe.vue?vue&type=script&lang=js&"
import style0 from "./fkShouYe.vue?vue&type=style&index=0&id=68ac4ae9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports